export default __webpack_public_path__ + "static/media/drug-screen.ede149c5.png";